import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound: React.FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Automatically redirect to home page after a brief delay
    const timer = setTimeout(() => {
      navigate('/', { replace: true })
    }, 100)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <p className="text-gray-600">Redirecting to home page...</p>
      </div>
    </div>
  )
}

export default NotFound
